import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import { ReactComponent as SiemensLogo } from '../static/logos/sie-logo-white-rgb.svg'
import { clearAuthentication, getAuthentication, isAuthenticated } from '../api/auth'

export default class Header  extends Component {

  constructor(props) {
    super(props)

    this.state = {
      isActive: false
    }
  }

  toggleBurgerMenu = () => {
    this.setState({isActive: !this.state.isActive})
  }

  render() {
    const showNavigation = this.props.showNavigation

    const displayAuthInfo = () => {
      const auth = getAuthentication()

      return (
        <div>
          <a className="navbar-item">
            <span className='has-text-weight-bold'>{auth.entity}</span>&nbsp;&nbsp;|&nbsp;&nbsp;{auth.name}
          </a>
        </div>
      )
    }

    return (
      <nav
        className="navbar is-fixed-top"
        role="navigation"
        aria-label="main navigation"
      >
        <div className="navbar-brand">
          <a className="navbar-item" href="/">
            <SiemensLogo className="navbar-logo" />
          </a>
  
          {showNavigation && (
            <div
              className={`navbar-burger burger ${this.state.isActive ? 'is-active' : ''}`}
              data-target="navbar"
              aria-label="menu"
              aria-expanded="false"
              onClick={this.toggleBurgerMenu}
            >
              <span></span>
              <span></span>
              <span></span>
            </div>
          )}
        </div>
  
        {showNavigation && (
          <div
            id="navbar"
            className={`navbar-menu ${this.state.isActive ? 'is-active' : ''}`}
          >
            <div className="navbar-start">
              <Link
                to="/"
                className="navbar-item is-tab"
                onClick={this.toggleBurgerMenu}
              >
                Início
              </Link>
              <Link
                to="/reports"
                className="navbar-item is-tab"
                onClick={this.toggleBurgerMenu}
              >
                Relatórios
              </Link>
              <Link
                to="/explorer"
                className="navbar-item is-tab"
                onClick={this.toggleBurgerMenu}
              >
                Explorador de Leituras
              </Link>             
              <Link
                to="/about"
                className="navbar-item is-tab"
                onClick={this.toggleBurgerMenu}
              >
                Sobre
              </Link>             
              {/* <Link
                to="/admin"
                className="navbar-item is-tab"
                onClick={this.toggleBurgerMenu}
              >
                Admin
              </Link>              */}
            </div>
  
            <div className="navbar-end">

              <div className="navbar-item">
                {isAuthenticated() && displayAuthInfo()}
              </div>

              <div className="navbar-item">
                <a className="navbar-item" href="/" onClick={() => clearAuthentication()}>
                  Logout
                </a>
              </div>
            </div>
          </div>
        )}
      </nav>
    )
  }
}
